import { all, fork } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import { deleteScreensaverSuccess } from 'modules/screensaver/actions/core';
import * as types from 'modules/screensaver/actionTypes';

import screensaverDashboardSaga from './dashboard';
import screensaverDetailsSaga from './details';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.CREATE_SCREENSAVER]: {
    notifications: {
      success: {
        id: 'page.screensaver.create.success',
        defaultMessage: 'Screensaver created successfully.',
      },
      failure: {
        id: 'page.screensaver.create.error',
        defaultMessage: 'An error occurred while creating the screensaver.',
      },
    },
  },
  [types.DELETE_SCREENSAVER]: {
    notifications: {
      success: {
        id: 'page.screensaver.delete.success',
        defaultMessage: 'Screensaver deleted successfully.',
      },
      failure: {
        id: 'page.screensaver.delete.error',
        defaultMessage: 'An error occurred while deleting the screensaver.',
      },
    },
    callbacks: {
      success: (_, meta, { payload: { screensaverId } }) => deleteScreensaverSuccess(screensaverId, meta),
    },
  },
  [types.UPDATE_SCREENSAVER]: {
    notifications: {
      success: {
        id: 'page.screensaver.update.success',
        defaultMessage: 'Screensaver updated successfully.',
      },
      failure: {
        id: 'page.screensaver.update.error',
        defaultMessage: 'An error occurred while updating the screensaver.',
      },
    },
  },
  [types.CLONE_SCREENSAVER]: {
    notifications: {
      success: {
        id: 'page.screensaver.clone.success',
        defaultMessage: 'Screensaver cloned successfully.',
      },
      failure: {
        id: 'page.screensaver.clone.error',
        defaultMessage: 'An error occurred while cloning the screensaver.',
      },
    },
  },
};

export default function* screensaverCoreSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield fork(screensaverDashboardSaga);
  yield fork(screensaverDetailsSaga);
}
